import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import EnterImage from "../../../../../assets/images/enter 1.png";
import axios from "axios";
import { Markup } from "interweave";
import AllDataHeader from "../../../../Reuseable/AllDataHeader";
import cup from "../../../../../assets/images/cup 2.png";
import Nodata from "../../../../../assets/Icon/Nodata.png";
import LoaderPost from "../../../../Reuseable/LoaderPost";
import { serverInfo } from "../../../../../App";
import { useContext } from "react";
const PendingAuditionSliderStar = () => {
  const { imageCdnUrl } = useContext(serverInfo);
  let history = useHistory();

  const [pendingAuditions, setPendingAudition] = useState([]);
  const [buffer, setBuffer] = useState(true);
  useEffect(() => {
    axios.get(`/api/superstar/audition/pendings`).then((res) => {
      setBuffer(false);
      if (res.status === 200) {
        setPendingAudition(res.data.pending_auditions);
      }
    });
  }, []);

  const handlePending = () => {
    // history.push('/superstar-admin/audition/create-event')
  };

  return (
    <>
      <AllDataHeader title="Pending Auditions" image={cup} count={"Zero"} />
      {buffer ? (
        <LoaderPost />
      ) : (
        <>
          {pendingAuditions.length !== 0 ? (
            <div className="row">
              {pendingAuditions?.map((audition) => (
                <div className="col-sm-12 col-md-6 col-lg-3 p-3 mb-3">
                  <div className="completedMeetupBlack">
                    <img
                      src={imageCdnUrl+audition.banner}
                      className="img-fluid w-100"
                      alt=""
                      style={{
                        height: "200px",
                        width: "100%",
                      }}
                    />
                    <div onClick={handlePending} className="p-3">
                      <div className="d-flex justify-content-between">
                        <Link
                          to={`/superstar/auditions/pending/${audition.id}`}
                          style={{ textDecoration: "none" }}
                        >
                          <h5 className="text-white">{audition.title}</h5>
                        </Link>
                        <img className="img-fluid" src={EnterImage} alt="" />
                      </div>

                      <p className="text-secondary">
                        <Markup content={audition.description} />
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <>
              <div className="row justify-content-center align-items-center">
                <div className="d-flex col-md-12 justify-content-center align-items-center my-5">
                  <img src={Nodata} alt="" className=" Nodata" />
                </div>
              </div>
            </>
          )}
        </>
      )}
    </>
  );
};

export default PendingAuditionSliderStar;
